"use client";

import styles from "@/styles/modules/components/tabs.module.scss";
import { useContext, useEffect, useState } from "react";
import Content from "@/components/Content";
import { TabsComponent } from "@/types/modules";
import { LanguageContext } from "@/context/languageContext";
import { translate } from "@/utils/translate";

interface TabsProps {
  tabs: TabsComponent[] | null;
}

export default function Tabs({ tabs }: TabsProps) {
  const { language } = useContext(LanguageContext);
  const [selected, setSelected] = useState<number>(0);

  useEffect(() => {
    const hash = window.location.hash.split("#")[1];

    if (hash && !isNaN(Number(hash))) {
      setSelected(Number(hash));
    }
  }, []);

  if (!tabs) return null;

  return (
    <section className={styles.tabs}>
      <div className={styles.tabsContainer}>
        <div className={styles.selectors} data-aos="fadeIn">
          {tabs.map((tab, i) => (
            <span
              key={i}
              className={`${i === selected ? styles.selected : ""}`}
              onClick={() => setSelected(i)}
            >
              {tab.title}
            </span>
          ))}
        </div>
        <div className={styles.items} data-aos="fadeIn" data-aos-delay="200">
          {tabs.map((tab, i) => (
            <article
              key={i}
              className={`${styles.item} ${
                i === selected ? styles.selected : ""
              }`}
            >
              <Content
                content={{
                  imageAlign: tab.imageAlign,
                  textAlign: tab.textAlign,
                  content: tab.content,
                  gallery: tab.gallery,
                  ...(tab.button && tab.button.title
                    ? {
                        button: tab.button,
                      }
                    : tab.isRestaurant && {
                        buttonRestaurants: {
                          text: translate["bookATable"][language],
                          restaurant: tab.slug,
                        },
                      }),
                }}
              />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
